import { supabase } from '../config/supabase';
import { NewHire } from './hireService';

export const getOwnerArchivedHires = async (): Promise<NewHire[]> => {
  console.log('Fetching archived hires for owner...');
  
  // First, get the current user
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    console.error('Error getting current user:', authError);
    throw new Error('User not authenticated');
  }

  // Get the current user's profile to retrieve their org_id and role
  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('org_id, role')
    .eq('id', user.id)
    .single();

  if (profileError || !profile) {
    console.error('Error fetching user profile:', profileError);
    throw new Error('Could not fetch user profile');
  }

  // Check if user is owner
  if (profile.role !== 'owner') {
    console.error('Access denied: User is not an owner');
    throw new Error('Access denied: Only owner users can view all archived hires');
  }

  // Fetch all archived hires for the owner's organization
  const { data, error } = await supabase
    .from('new_hire_archive')
    .select('*')
    .eq('org_id', profile.org_id)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching archived hires:', error);
    throw error;
  }

  // Convert progress to number for each hire
  const processedData = data?.map(hire => ({
    ...hire,
    progress: Number(hire.progress)
  })) || [];

  console.log('Fetched archived hires for owner org_id:', profile.org_id, 'Data:', processedData);
  return processedData;
}; 